declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}

export type DigitalVosPdfBridgeMessage =
  | {type: 'DIGITAL_VOS_PDF'; fileName: string; base64: string}
  | {type: 'DIGITAL_VOS_PDF_ERROR'; message: string}
  | {type: 'DIGITAL_VOS_CLOSE'}

export function isReactNativeWebView(): boolean {
  return typeof window !== 'undefined' && Boolean(window.ReactNativeWebView?.postMessage)
}

export function postPdfToReactNative(fileName: string, base64: string): void {
  const payload: DigitalVosPdfBridgeMessage = {
    type: 'DIGITAL_VOS_PDF',
    fileName,
    base64,
  }
  window.ReactNativeWebView?.postMessage(JSON.stringify(payload))
}

export function postPdfErrorToReactNative(message: string): void {
  const payload: DigitalVosPdfBridgeMessage = {
    type: 'DIGITAL_VOS_PDF_ERROR',
    message,
  }
  window.ReactNativeWebView?.postMessage(JSON.stringify(payload))
}

export function postCloseToReactNative(): void {
  const payload: DigitalVosPdfBridgeMessage = {type: 'DIGITAL_VOS_CLOSE'}
  window.ReactNativeWebView?.postMessage(JSON.stringify(payload))
}
